@import 'styles/mixins';
@import 'styles/variables';

.chevron {
  margin: 0 4px;
}
